import React, {Component} from 'react'


const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <img {...props} src="/img/arrow-big.svg"/>
);

export default SlickArrowRight
